<template lang="html">
  <li class="clientItem" :class="{empty:!quote}">
    <div class="clientItem__image" :style="{backgroundImage: `url(${image})`}"></div>
    <blockquote class="clientItem__textContainer">
      <q>{{quote}}</q>
      <p>{{author}}</p>
      <p>{{job}}</p>
    </blockquote>
  </li>
</template>

<script>
export default {
  name: 'ClientItem',
  props: ['image','client','quote','author','job']
}
</script>

<style lang="scss">
@import "../styles/config.scss";
.clientItem {
  text-align: center;
  &__image {
    height: 160px;
    max-width: 140px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    overflow: hidden;
    margin: 0 auto;
  }
  &__textContainer {
    border-radius: 50%;
    width: 320px;
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: var(--Neu01);
    padding: 50px;
    text-align: left;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%) scale(.5);
    opacity: 0;
    transition: all .3s cubic-bezier(.41,.15,.41,1.31);
    q {
      font-family: CamptonBook;
      font-size: 18px;
      color: var(--Neu10);
      margin-bottom: 15px;
      width: 100%;
    }
    p {
      font-family: CamptonBold;
      font-size: 12px;
      line-height: 1.5;
      color: var(--M01);
      width: 100%;
    }
  }
  &:hover {
    .clientItem__textContainer {
      transform: translate(-50%,-50%) scale(1);
      opacity: 1;
    }
  }
  &.empty:hover {
    .clientItem__textContainer {
      // transform: translate(-50%,-50%) scale(1);
      opacity: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ClientItem.vue